export default __webpack_public_path__ + "static/media/menu.3d98a153.svg";